var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F04438"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5C7.8675 4.5 4.5 7.8675 4.5 12C4.5 16.1325 7.8675 19.5 12 19.5C16.1325 19.5 19.5 16.1325 19.5 12C19.5 7.8675 16.1325 4.5 12 4.5ZM11.4375 9C11.4375 8.6925 11.6925 8.4375 12 8.4375C12.3075 8.4375 12.5625 8.6925 12.5625 9V12.75C12.5625 13.0575 12.3075 13.3125 12 13.3125C11.6925 13.3125 11.4375 13.0575 11.4375 12.75V9ZM12.69 15.285C12.6525 15.3825 12.6 15.4575 12.5325 15.5325C12.4575 15.6 12.375 15.6525 12.285 15.69C12.195 15.7275 12.0975 15.75 12 15.75C11.9025 15.75 11.805 15.7275 11.715 15.69C11.625 15.6525 11.5425 15.6 11.4675 15.5325C11.4 15.4575 11.3475 15.3825 11.31 15.285C11.2725 15.195 11.25 15.0975 11.25 15C11.25 14.9025 11.2725 14.805 11.31 14.715C11.3475 14.625 11.4 14.5425 11.4675 14.4675C11.5425 14.4 11.625 14.3475 11.715 14.31C11.895 14.235 12.105 14.235 12.285 14.31C12.375 14.3475 12.4575 14.4 12.5325 14.4675C12.6 14.5425 12.6525 14.625 12.69 14.715C12.7275 14.805 12.75 14.9025 12.75 15C12.75 15.0975 12.7275 15.195 12.69 15.285Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.cefbb1162369d81c967f2828e2610c35.svg";
export { ForwardRef as ReactComponent };